"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-5f2799ae"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 1,
    class: "text-red font-bold"
};
const vue3_1 = __importDefault(require("@fullcalendar/vue3"));
const timegrid_1 = __importDefault(require("@fullcalendar/timegrid"));
const interaction_1 = __importDefault(require("@fullcalendar/interaction"));
const hu_1 = __importDefault(require("@fullcalendar/core/locales/hu"));
const en_gb_1 = __importDefault(require("@fullcalendar/core/locales/en-gb"));
const ro_1 = __importDefault(require("@fullcalendar/core/locales/ro"));
const vue_3 = require("vue");
const fullCalendarStore_1 = require("../../stores/fullCalendar/fullCalendarStore");
const vue_datepicker_1 = __importDefault(require("@vuepic/vue-datepicker"));
require("@vuepic/vue-datepicker/dist/main.css");
const i18n_1 = __importDefault(require("../../common/i18n"));
const i18n_2 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FullCalendarComponent',
    props: {
        title: {},
        appointments: {},
        selectedDate: {},
        locationId: {},
        serviceBayId: {},
        calendarMarkers: {}
    },
    emits: [
        "clickEvent",
        "pasteEventAfter",
        "getSelectedDate",
        "calendarHandleMonthYear",
        "createNewAppointment",
    ],
    setup(__props, { emit }) {
        var _a;
        const props = __props;
        const currentLang = (0, vue_3.computed)(() => i18n_2.i18n.locale.value);
        const calendarLocale = (0, vue_3.computed)(() => {
            switch (i18n_2.i18n.locale.value) {
                case "hu":
                    return hu_1.default;
                case "ro":
                    return ro_1.default;
                case "en":
                default:
                    return en_gb_1.default;
            }
        });
        //import { Translator } from "../../common/i18n";
        //import { cloneDeep } from "lodash";
        //console.log(trans.locale());
        const fullCalendarStore = (0, fullCalendarStore_1.useFullCalendarStore)();
        const handleMonthYear = ({ month, year }) => {
            var _a;
            if (props.locationId !== 0) {
                emit("calendarHandleMonthYear", year, month, props.locationId, (_a = selectedEvent.value) === null || _a === void 0 ? void 0 : _a.extendedProps.serviceId);
            }
        };
        const renderKey = (0, vue_3.ref)(0);
        // eslint-disable-next-line vue/no-dupe-keys
        const title = (0, vue_3.ref)(props.title || "Default title");
        const date = (0, vue_3.ref)(props.selectedDate);
        let calendarOptions = {
            plugins: [timegrid_1.default, interaction_1.default],
            initialDate: date.value,
            initialView: "timeGridDay",
            headerToolbar: {
                left: "",
                center: "",
                right: "",
            },
            eventClick: (info) => {
                //bal kattintásra
                openEvent(info);
            },
            eventDragStart: function (info) {
                fullCalendarStore.draggedFrom = info;
            },
            eventDidMount: (arg) => {
                //Jobb kattintásra event kiváltása
                arg.el.addEventListener("contextmenu", (jsEvent) => {
                    showClipMenuPoint.value = true;
                    showPasteMenuPoint.value = false;
                    showCreateNewMenuPoint.value = false;
                    jsEvent.preventDefault();
                    const mouseEvent = jsEvent;
                    contextMenuX.value = mouseEvent.pageX;
                    contextMenuY.value = mouseEvent.pageY;
                    showContextMenu.value = true;
                    selectedEvent.value = arg.event;
                });
            },
            eventDrop: function (info) {
                if (window.confirm(i18n_1.default.trans("confirm_copy", "Are you sure you want to reschedule this appointment?", "fullcalendar"))) {
                    // Adott timegriden belüli áthelyezésnél ez fut le
                    if (info.event.start && info.event.end) {
                        pasteEventAfter(parseInt(info.event.id), info.event.start, info.event.end, props.serviceBayId);
                    }
                }
                else {
                    info.revert();
                }
            },
            eventReceive: function (info) {
                if (window.confirm(i18n_1.default.trans("confirm_copy", "Are you sure you want to reschedule this appointment?", "fullcalendar"))) {
                    //Másik timegridbe helyezésnél (service bay) ez fut le
                    if (info.event.start && info.event.end) {
                        pasteEventAfter(parseInt(info.event.id), info.event.start, info.event.end, props.serviceBayId);
                    }
                }
                else {
                    //mivel külön timegridben van egy globális storeban kell lekövetni a változásokat az info.revert csak eltávolítja az áthelyezett timegridből de nem állítja vissza az eredeti timegridbe
                    if (fullCalendarStore.draggedFrom) {
                        const calendar = fullCalendarStore.draggedFrom.view.calendar;
                        calendar.addEvent(fullCalendarStore.draggedFrom.event);
                        info.revert();
                        fullCalendarStore.draggedFrom = null;
                    }
                    //console.log(fullCalendarStore.draggedFrom);
                }
            },
            eventResize: function (info) {
                if (window.confirm(i18n_1.default.trans("confirm_resize", "Are you sure you want to resize this date?", "fullcalendar"))) {
                    // Event átméretezése
                    if (info.event.end && info.event.start) {
                        pasteEventAfter(parseInt(info.event.id), info.event.start, info.event.end, props.serviceBayId);
                    }
                }
                else {
                    info.revert();
                }
            },
            dateClick: function (info) {
                emit("createNewAppointment", info.date, props.serviceBayId, props.locationId);
            },
            events: props.appointments,
            selectable: false,
            editable: true,
            droppable: true,
            slotDuration: "00:10:00",
            contentHeight: 2000,
            allDaySlot: false,
            locale: (_a = calendarLocale.value) !== null && _a !== void 0 ? _a : en_gb_1.default,
            slotLabelFormat: {
                hour: "2-digit",
                minute: "2-digit",
                omitZeroMinute: false,
                meridiem: false,
            },
            expandRows: true,
            slotMinTime: "07:30",
            slotMaxTime: "20:00",
            // Állítsd be az egyedi szöveget az első oszlop fejlécében
            dayHeaderContent: (args) => {
                // Zászló az első oszlop azonosítására
                let isFirstColumn = false;
                // Ellenőrizzük, hogy az aktuális oszlop az első-e
                if (args.view.currentStart.toISOString() === args.date.toISOString()) {
                    isFirstColumn = true;
                }
                // Ha az aktuális oszlop az első oszlop
                if (isFirstColumn) {
                    return { html: title.value };
                }
                // Különben térj vissza az alapértelmezett fejléc formátummal (hét napja, hónap napja)
                return {
                    html: args.date.toLocaleDateString(undefined, {
                        weekday: "short",
                        month: "numeric",
                        day: "numeric",
                    }),
                };
            },
            eventContent: (args) => {
                const event = args.event;
                //const from = event.extendedProps.from;
                //${event.title}
                let mark;
                if (event.extendedProps.status === "New") {
                    const svgExclamationCircle = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>`;
                    mark = document.createElement("span");
                    mark = document.createElement("span");
                    mark.classList.add("circle-mark", "exclamation");
                    mark.innerHTML =
                        '<span class="background"></span>' + svgExclamationCircle;
                }
                else {
                    mark = document.createElement("span");
                }
                //let wheelText = event.extendedProps.isWheel ? "Felnivel" : "Felni nélkül";
                let wheelText = event.extendedProps.isWheel
                    ? i18n_1.default.trans("with_rim", "With rim", "fullcalendar")
                    : i18n_1.default.trans("without_rim", "Without rim", "fullcalendar");
                return {
                    html: `
        <div class="event-wrapper">
          ${mark.outerHTML}
          <div class="event-title">
            <div class="gyarto">${event.extendedProps.gyarto} ${event.extendedProps.modell}</div>
            <div class="rendszam">${wheelText}</div>
            </div>
        </div>
      `,
                };
            },
            /*eventClassNames: (args) => {
            const event = args.event;
            const from = event.extendedProps.from;
            return ["event-from-" + from.toLowerCase()];
          },*/
            eventClassNames: (args) => {
                if (args.event.extendedProps.status === "Rejected") {
                    return ["event-top-border", "rejected-appointment"];
                }
                else {
                    return ["event-top-border"];
                }
            },
            slotLaneDidMount(info) {
                if (info.date) {
                    const slotTime = new Date();
                    const infoDate = new Date(info.date.toString());
                    slotTime.setHours(infoDate.getHours(), infoDate.getMinutes(), 0);
                    slotTime.setFullYear(props.selectedDate.getFullYear());
                    slotTime.setMonth(props.selectedDate.getMonth());
                    slotTime.setDate(props.selectedDate.getDate());
                    const now = new Date();
                    const slotElement = info.el.closest("tr");
                    if (slotTime < now) {
                        if (slotElement) {
                            slotElement.classList.add("past-slot");
                        }
                    }
                    if (slotTime.getMinutes() === 0) {
                        if (slotElement) {
                            slotElement.classList.add("hour-border");
                        }
                    }
                }
            },
        };
        let showClipMenuPoint = (0, vue_3.ref)(false);
        let showPasteMenuPoint = (0, vue_3.ref)(false);
        let showContextMenu = (0, vue_3.ref)(false);
        let showCreateNewMenuPoint = (0, vue_3.ref)(false);
        let contextMenuX = (0, vue_3.ref)(0);
        let contextMenuY = (0, vue_3.ref)(0);
        let selectedEvent = (0, vue_3.ref)(null);
        let pasteDate = (0, vue_3.ref)(null);
        let pasteServiceBay = (0, vue_3.ref)(0);
        function hideContextMenu() {
            showContextMenu.value = false;
        }
        function clippingEvent() {
            handleMonthYear({
                year: props.selectedDate.getFullYear(),
                month: props.selectedDate.getMonth(),
            });
            fullCalendarStore.clipboard = selectedEvent.value;
        }
        function pasteEvent() {
            if (fullCalendarStore.clipboard &&
                pasteDate.value &&
                fullCalendarStore.clipboard.end &&
                fullCalendarStore.clipboard.start) {
                const dateDiff = fullCalendarStore.clipboard.end.getTime() -
                    fullCalendarStore.clipboard.start.getTime();
                pasteEventAfter(parseInt(fullCalendarStore.clipboard.id), pasteDate.value, new Date(pasteDate.value.getTime() + dateDiff), pasteServiceBay.value);
                fullCalendarStore.clipboard = null;
                //appointmentsCopy.value.push(newEvent);
            }
        }
        //Új időpont szöveg megjelenítése mouseover eseményre
        (0, vue_3.onMounted)(() => {
            const slots = document.querySelectorAll(".fc-timegrid-slot-lane");
            slots.forEach((slot) => {
                slot.addEventListener("mouseover", handleMouseOver);
                slot.addEventListener("mouseout", handleMouseOut);
            });
        });
        const handleMouseOver = (event) => {
            const target = event.target;
            target.innerText = i18n_1.default.trans("new_appointment", "Create new appointment", "reservation_modal");
        };
        const handleMouseOut = (event) => {
            const target = event.target;
            target.innerText = "";
        };
        //jobbklikk a time slotra megnyitja a menüt és lekéri az időt belőle
        (0, vue_3.onMounted)(() => {
            const handler = (event) => {
                const target = event.target;
                // Check if the target is a FullCalendar timegrid cell
                const cell = target.closest(".fc-timegrid-slot-lane");
                if (cell) {
                    showCreateNewMenuPoint.value = true;
                    showClipMenuPoint.value = false;
                    showPasteMenuPoint.value = true;
                    event.preventDefault();
                    // Get the data-time attribute of the cell
                    const datetime = cell.getAttribute("data-time");
                    if (datetime) {
                        // The time is represented as "HH:MM:SS"
                        const [hour, minute, second] = datetime.split(":").map(Number);
                        // Get the date of the clicked cell
                        // Assume we are on the current day
                        const date = new Date(props.selectedDate.toISOString());
                        date.setHours(hour, minute, second);
                        const serviceBayElement = target.closest("[data-service-bay]");
                        if (serviceBayElement) {
                            const serviceBayId = serviceBayElement.getAttribute("data-service-bay");
                            if (serviceBayId) {
                                pasteServiceBay.value = parseInt(serviceBayId);
                            }
                        }
                        pasteDate.value = date;
                        const mouseEvent = event;
                        contextMenuX.value = mouseEvent.pageX;
                        contextMenuY.value = mouseEvent.pageY;
                        showContextMenu.value = true;
                    }
                }
            };
            document.addEventListener("contextmenu", handler);
            (0, vue_3.onUnmounted)(() => {
                document.removeEventListener("contextmenu", handler);
            });
        });
        // ha a fullcalendaron kívűl kattint akkor eltűnik a menü
        let contextMenuElement = (0, vue_3.ref)(null);
        const handleClickOutside = (e) => {
            var _a;
            const targetElement = e.target; // e.targetet Node típusra állítjuk
            if (!((_a = contextMenuElement.value) === null || _a === void 0 ? void 0 : _a.contains(targetElement))) {
                showContextMenu.value = false;
            }
        };
        (0, vue_3.onMounted)(() => {
            document.addEventListener("click", handleClickOutside);
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener("click", handleClickOutside);
        });
        const openEvent = (clickedEvent) => {
            emit("clickEvent", clickedEvent.event);
        };
        const pasteEventAfter = (id, newStart, newEnd, newServiceBay) => {
            emit("pasteEventAfter", id, newStart, newEnd, newServiceBay);
        };
        const getSelectedDate = (date) => {
            emit("getSelectedDate", date);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue3_1.default), {
                    key: renderKey.value,
                    options: (0, vue_2.unref)(calendarOptions),
                    class: "custom-columns",
                    "data-service-bay": props.serviceBayId
                }, null, 8, ["options", "data-service-bay"])),
                ((0, vue_2.unref)(showContextMenu))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        ref_key: "contextMenuElement",
                        ref: contextMenuElement,
                        style: (0, vue_2.normalizeStyle)({ top: `${(0, vue_2.unref)(contextMenuY)}px`, left: `${(0, vue_2.unref)(contextMenuX)}px` }),
                        class: "context-menu",
                        onClick: hideContextMenu
                    }, [
                        ((0, vue_2.unref)(fullCalendarStore).clipboard && (0, vue_2.unref)(showPasteMenuPoint))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "menu-point",
                                onClick: pasteEvent
                            }, (0, vue_2.toDisplayString)(_ctx.$trans("paste_button", "Paste", "fullcalendar")), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!(0, vue_2.unref)(showClipMenuPoint) && !(0, vue_2.unref)(fullCalendarStore).clipboard)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_1, (0, vue_2.toDisplayString)(_ctx.$trans("nothig_on_clipboard", "Nothing on the clipboard!", "fullcalendar")), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_datepicker_1.default), {
                            modelValue: date.value,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((date).value = $event)),
                                getSelectedDate
                            ],
                            class: "date-picker",
                            locale: currentLang.value,
                            "enable-time-picker": false,
                            "show-buttons": false,
                            "auto-apply": "",
                            clearable: false,
                            "close-on-scroll": "",
                            markers: _ctx.calendarMarkers,
                            position: "left",
                            "min-date": new Date(),
                            onUpdateMonthYear: handleMonthYear
                        }, {
                            trigger: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.unref)(showClipMenuPoint))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        class: "menu-point",
                                        onClick: clippingEvent
                                    }, (0, vue_2.toDisplayString)(_ctx.$trans("clip_button", "Clip", "fullcalendar")), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "locale", "markers", "min-date"])
                    ], 4))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
